import { render, staticRenderFns } from "./CreateKeywords.vue?vue&type=template&id=a7c82f1c&scoped=true&"
import script from "./CreateKeywords.vue?vue&type=script&lang=js&"
export * from "./CreateKeywords.vue?vue&type=script&lang=js&"
import style0 from "./CreateKeywords.vue?vue&type=style&index=0&id=a7c82f1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7c82f1c",
  null
  
)

export default component.exports